export const DateCellRenderer = ({ value }) => {
  if (!value) return <span />

  let valueStr = value.toString();
  return <span>{valueStr.substring(4, 6) + '/' + valueStr.substring(6, 8) + '/' + valueStr.substring(0, 4)}</span>
}